import { realEntityName, type SetupSuiteView } from '@pqrs/contracts';
import { EstadoPendiente } from '@xiltrion/ui/bloques/estados';
import { Button } from '@xiltrion/ui/button';
import { Icono } from '@xiltrion/ui/icono';
import { Spinner } from '@xiltrion/ui/spinner';
import { useSession } from '@/app/session';
import { notifyError } from '@/features/config/shared';
import { useRecheckSetup } from './api';

/**
 * Lo que ve el Administrador en la puesta en marcha mientras la suite no le asigna a SGDEA el correo saliente y el
 * almacenamiento de la entidad: sin ellos la puesta en marcha no empieza. Lo asigna un superadministrador de la suite.
 */
export function SuitePendingPage({ suite }: { suite: SetupSuiteView }) {
  const { me } = useSession();
  const recheck = useRecheckSetup();
  // «el correo saliente y el almacenamiento de documentos»: los dos son masculinos.
  const missing = suite.missing.map((m) => `el ${m.title.toLowerCase()}`).join(' y ');
  return (
    <EstadoPendiente
      titulo="La entidad aún no está lista en la suite"
      descripcion={`Antes de la puesta en marcha falta configurar en la suite ${missing} de ${realEntityName(me?.entity.name) ?? 'la entidad'}. Pídaselo a soporte; cuando esté listo podrás empezar aquí.`}
      accion={
        <Button variant="outline" onClick={() => recheck.mutate(undefined, { onError: notifyError })} disabled={recheck.isPending}>
          {recheck.isPending ? <Spinner /> : <Icono nombre="mdi:refresh" />} Revisar de nuevo
        </Button>
      }
    />
  );
}
